export function postAjax(url, data, success) {

    const params = typeof data == 'string' ? data : Object.keys(data).map(
        function (k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
        }
    ).join('&');

    const xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');

    xhr.open('POST', url, true);

    xhr.onreadystatechange = function () {
        if (xhr.readyState > 3 && xhr.status === 200)
            success(xhr.responseText)
    };

    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('X-CSRF-TOKEN', document.head.querySelector('meta[name="csrf-token"]').content);
    xhr.send(params);

    return xhr;
}

export function toggle(el) {

    if ( el.style.display === 'block' )
        el.style.display = 'none';
    else
        el.style.display = 'block';
}

export function isJson(str) {

    try {
        JSON.parse(str)
    } catch (e) {
        return false
    }

    return true
}

export function getFromCategoriesBy(index, categories) {

    // if index is last
    // if ( index === 'last' ) {
    //     return categories[categories.length - 1].name
    // }

    // if index is first
    // if ( index === 'first' ) {
    //     return categories[0].name
    // }

    // if index is number
    if ( typeof index === 'number' ) {
        let position = categories.length - index

        if ( position < 0 ) {
            return ''
        } else {
            // category exists with this position && category id is not 1
            if ( categories[position] && categories[position].pivot.category_id !== 1 ) {
                return categories[position].name
            } else {
                return ''
            }
        }
    }

    return ''
}

// write function from helpers.php getCategoryByPosition to javascript
export function getCategoryByPosition(position, categories) {
    let category = categories[categories.length - position]

    if ( category && category.pivot.category_id !== 1 ) {
        return category.name
    } else {
        return ''
    }
}

export function disableSendButton(){
    const button = document.getElementById('send-order-button');
    if(button){
        button.disabled = true;
        button.style.backgroundColor = 'gray';
        button.style.opacity = '0.6';
        button.style.cursor = 'not-allowed';
    }
}
